export class MaxFieldError extends Error {
  constructor(max: number) {
    super(`O valor não pode ser maior que ${max}.`);
    this.name = 'MaxFieldError';
  }
}
